<template>
  <div>
    <h2>Operational Users</h2>
    <div v-if="operationalUsers.length">
      <table class="data-table">
        <thead>
          <tr>
            <th>Email</th>
            <th>Assign Role</th>
            <th>Embark</th>
            <th>Debark</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in operationalUsers" :key="user.id">
            <td>{{ user.email }}</td>
            <td>
              <select v-model="selectedRoles[user.id]" @change="$emit('update-user-role', user.id)">
                <option v-for="role in roles" :key="role.id" :value="role.id">
                  {{ role.name }}
                </option>
              </select>
            </td>
            <td>
              <div class="collection-cell">
                <span v-for="call in getUserEmbarkCalls(user)" :key="call.id" class="collection-item">
                  {{ call.operationDate }}
                  <b-button size="sm" variant="danger" @click="$emit('remove-ship-call', user.id, call.id)">x</b-button>
                </span>
                <b-button size="sm" variant="success" @click="$emit('add-ship-call', user.id, 'embarkation')">+</b-button>
                <b-form-select v-if="addingShipCall[user.id]?.type === 'embarkation'"
                  v-model="addingShipCall[user.id].value" :options="availableEmbarkOptions(user)" size="sm"
                  @change="$emit('confirm-add-ship-call', user.id)"></b-form-select>
              </div>
            </td>
            <td>
              <div class="collection-cell">
                <span v-for="call in getUserDebarkCalls(user)" :key="call.id" class="collection-item">
                  {{ call.operationDate }}
                  <b-button size="sm" variant="danger" @click="$emit('remove-ship-call', user.id, call.id)">x</b-button>
                </span>
                <b-button size="sm" variant="success" @click="$emit('add-ship-call', user.id, 'debarkation')">+</b-button>
                <b-form-select v-if="addingShipCall[user.id]?.type === 'debarkation'"
                  v-model="addingShipCall[user.id].value" :options="availableDebarkOptions(user)" size="sm"
                  @change="$emit('confirm-add-ship-call', user.id)"></b-form-select>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>No users found.</div>
  </div>
</template>

<script>
export default {
  name: 'UserTable',
  props: {
    users: { type: Array, required: true },
    roles: { type: Array, required: true },
    shipCalls: { type: Array, required: true },
    selectedRoles: { type: Object, required: true },
    selectedShipCalls: { type: Object, required: true },
    addingShipCall: { type: Object, required: true },
  },
  computed: {
    operationalUsers() {
      return this.users;
    },
  },
  methods: {
    getUserEmbarkCalls(user) {
      return (this.selectedShipCalls[user.id] || []).filter(call => call.operationType === 'embarkation');
    },
    getUserDebarkCalls(user) {
      return (this.selectedShipCalls[user.id] || []).filter(call => call.operationType === 'debarkation');
    },
    availableEmbarkOptions(user) {
      const currentIds = (this.selectedShipCalls[user.id] || []).map(c => c.id);
      return this.shipCalls
        .filter(call => call.operationType === 'embarkation' && !currentIds.includes(call.id))
        .map(call => ({
          value: call.id,
          text: call.operationDate,
        }));
    },
    availableDebarkOptions(user) {
      const currentIds = (this.selectedShipCalls[user.id] || []).map(c => c.id);
      return this.shipCalls
        .filter(call => call.operationType === 'debarkation' && !currentIds.includes(call.id))
        .map(call => ({
          value: call.id,
          text: call.operationDate,
        }));
    },
  },
};
</script>

<style scoped>
.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.data-table th,
.data-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.data-table th {
  background-color: #f2f2f2;
}

.collection-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
}

.collection-item {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background-color: #f0f0f0;
  padding: 2px 5px;
  border-radius: 3px;
}

.collection-item button {
  padding: 0 4px;
}
</style>